import { render, staticRenderFns } from "./ContactSelectView.vue?vue&type=template&id=671d6190&scoped=true&"
import script from "./ContactSelectView.vue?vue&type=script&lang=js&"
export * from "./ContactSelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d6190",
  null
  
)

export default component.exports